import { render, staticRenderFns } from "./fieldDescription.vue?vue&type=template&id=29d2e8fb&scoped=true&"
import script from "./fieldDescription.vue?vue&type=script&lang=js&"
export * from "./fieldDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d2e8fb",
  null
  
)

export default component.exports